/*
|--------------------------------------------------------------------------
| Candidate Communication Defaults - 22 Sep 2026
|--------------------------------------------------------------------------
*/

const COMMUNICATION_DEFAULTS = {

  welcome: {

    subject:
        "Welcome to Catalyst!",

    messageContent:
        `
        <p>
            It is my great pleasure to see you as part of the
            <strong>Catalyst</strong> cohort and to join forces as you step up
            the growth momentum for yourself and <strong>&lt;your org&gt;</strong>.
            We will have the opportunity to work together to help you
            <strong>explore and expand</strong> the horizons of your
            “<strong>Possible</strong>” potential as you prepare for the
            journey ahead.
        </p>

        <p>
            While we will touch upon many facets connected to the program and
            building growth, the <strong>most important determinant is you</strong>.
            This program is what you will make of it.
        </p>

        <p>
            In <strong>the next 24 to 48 hours</strong>, I will be reaching out
            to you individually to check on a few items and to set up
            <strong>an initial one on one</strong> sync to learn more about you.
        </p>

        <p>
            <strong>&lt;&gt;</strong> and <strong>&lt;&gt;</strong> will be
            joining me in powering up this space, with a
            <strong>singular focus</strong>: how we can
            <strong>help you activate</strong> and unlock your own growth
            playbook.
        </p>

        <p>
            We will be sharing the lineup of key activities and actions needed
            to get started, including setting <strong>up a kick off</strong>
            call to provide additional insights into the program in the weeks
            and months ahead.
        </p>

        <p>
            <strong>Welcome aboard!</strong>
        </p>
        `,

  },


  onboarding_update: {

    subject:
        "Get ready for the Catalyst Experience!",

    messageContent:
        `
        <p>
            As we get ready to experience <strong>Catalyst</strong>, here are
            the immediate next steps for us to get done:
        </p>

        <ol>

            <li>
            <strong>Introductions - Initial 1:1s</strong> - The purpose of
            this space is to learn about each other and develop a sense of
            comfort. No expectations or preparation. Just bring yourself.
            <strong>Pick and choose a slot</strong> to engage with the
            Program Coach <strong>via the Trinity Slot Board</strong>. The
            details will be shared in a separate email. During this session,
            you will <strong>also be onboarded to Trinity</strong>, the
            platform for your Catalyst journey.
            </li>

            <li>
            <strong>Program Kick Off</strong> - Learn about the program premise,
            the design, engagement details, key expectations and time commitment.
            Please accept the invite and plan to join.
            </li>

            <li>
            <strong>InductiON Sessions</strong> - This is where we set the
            <strong>Catalyst</strong> in motion. Conducted in a “collective”
            and <strong>in person setting</strong> over 3 days. You have already
            confirmed your participation for this. Please accept the calendar
            invite for the same to block your calendars.
            </li>

            <li>
            <strong>Deep Dive Sessions</strong> - This is where your individual
            Catalyst journey begins. More on this in the kick off. For now,
            you’ll need to book or confirm your slot via the
            <strong>Trinity Slot Board</strong>. The details will be shared in
            a separate email.
            </li>

            <li>
            <strong>WhatsApp Communication Group</strong> - We will be creating
            a WhatsApp group for offline communication for key updates and reach
            outs. Please share your details by replying 1:1 to this email.
            </li>

            <li>
            <strong>Your Digital Pic</strong> - Please send your latest digital
            pic, square 2x2 preferred. This will be used for the events and
            updates connected to the program.
            </li>

        </ol>

        <p>
            <strong>
            We are igniting the Catalyst engine to activate your magic!
            </strong>
        </p>
        `,

  },

  initial_1on1: {

    subject:
        "Know your Catalyst Activator!",

    messageContent:
        `
        <p>
            Please visit the <strong>Trinity Slot Board</strong> to schedule
            <strong>your Initial 1:1 session</strong> with the Program Coach.
            Here are the details you need to know:
        </p>

        <p>
            <strong>Link to the Slot Board:</strong>
            <br />
            <strong>Passcode:</strong>
        </p>

        <ol>

            <li>
            <strong>On the slot board</strong>, you will
            <strong>see the list of available slots</strong> in different
            timezones. You can <strong>select your timezone</strong> on the
            right side box to display the slots in your timezone.
            </li>

            <li>
            <strong>Enter your name and your email address</strong> and an
            optional note.
            </li>

            <li>
            Click on the <strong>“Book Slot”</strong> button.
            </li>

        </ol>

        <p>
            You should receive a calendar invite in your email for the selected slot.
        </p>

        <p>
            <strong>That’s it!</strong>
        </p>

        <p>
            <strong>If you face any issue</strong> in accessing the slot board,
            then please respond to this email and provide a few slots
            (date, time, timezone) which work best for you. We will send you an
            invite separately.
        </p>
        `,

  },


  deep_dive: {

    subject:
        "Dive into your Individual Catalyst Activation!",

    messageContent:
        `
        <p>
            Please visit the <strong>Trinity Slot Board</strong> to schedule
            <strong>your deep dive session</strong> with the Program Coach.
            This session is planned after the three days of the
            <strong>in person</strong> “collective” InductiON sessions.
            This is where your individual Catalyst activation gets started.
        </p>

        <p>
            Here are the details you need to know:
        </p>

        <p>
            <strong>Link to the Slot Board:</strong>
            <br />
            <strong>Passcode:</strong>
        </p>

        <ol>

            <li>
            <strong>On the slot board</strong>, you will
            <strong>see the list of available slots</strong> in different
            timezones. You can <strong>select your timezone</strong> on the
            right side box to display the slots in your timezone.
            </li>

            <li>
            <strong>Enter your name and your email address</strong> and an
            optional note.
            </li>

            <li>
            Click on the <strong>“Book Slot”</strong> button.
            </li>

        </ol>

        <p>
            You should receive a calendar invite in your email for the selected slot.
        </p>

        <p>
            <strong>That’s it!</strong>
        </p>

        <p>
            <strong>If you face any issue</strong> in accessing the slot board,
            then please respond to this email and provide a few slots
            (date, time, timezone) which work best for you. We will send you an
            invite separately.
        </p>
        `,

  },

}

export {
    COMMUNICATION_DEFAULTS
}